import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import Form from 'components/Form/Form';

import useGroup from 'hooks/useGroup';

let updatePropsToChangeEstimate = false;

function OptionImage(props) {
	const {t} = useTranslation();
	const {
		group = false,
		type = false,
		/*setEstimate = () => {
		},
		//estimate = {},*/
		components = {}
	} = props;
	const [image, setImage] = useState(false);
	const [name, setName] = useState('');
	const [width, setWidth] = useState(false);
	const [height, setHeight] = useState(false);
	const [maxWidth, setMaxWidth] = useState(false);
	const [maxHeight, setMaxHeight] = useState(false);

	const {
		estimate,
		fetchingEstimate,
		estimateGroup
	} = useGroup();

	useEffect(() => {
		if (group !== false && group.config) {
			if (image !== group.config.image) {
				setImage(group.config.image);
			}
			if (name !== group.config.name) {
				setName(group.config.name);
			}
			if (name !== group.name) {
				setName(group.name);
			}


			if (group.config.maxHeight) {
				setMaxHeight(group.config.maxHeight);
			}

			if (group.config.maxWidth) {
				setMaxWidth(group.config.maxWidth);
			}

			if (width !== group.config.width) {
				setWidth(group.config.width);
			}

			if (height !== group.config.height) {
				setHeight(group.config.height);
			}
		}
	}, [group]);

	useEffect(() => {
		if (maxWidth === false && estimate.width !== false) {
			if (estimate.width !== maxWidth) {
				setMaxWidth(estimate.width);
			}
			if (estimate.width !== width) {
				setWidth(estimate.width);
			}
		}
		if (maxHeight === false && estimate.height !== false) {
			if (estimate.height !== maxHeight) {
				setMaxHeight(estimate.height);
			}
			if (estimate.height !== height) {
				setHeight(estimate.height);
			}
		}
	}, [estimate]);

	useEffect(() => {
		if (
			type !== false &&
			image !== false
		) {

			let completeParams = {
				width,
				height,
			}
			if (updatePropsToChangeEstimate) {
				setMaxHeight(false);
				setMaxWidth(false);
				completeParams = {};
			}


			let params = {
				type,
				image: typeof image.filePath !== 'undefined' ? image.filePath : image,
				estimation: true,
				...completeParams
			};
			estimateGroup(params);
			updatePropsToChangeEstimate = false;
		}
	}, [type, image, width, height]);

	const generate = () => {
		if (parseInt(type, 10) !== 2) {
			return;
		}
		if (image === false) {
			return alert(t('OptionImage.errors.imageMissing'));
		}
		if (name.trim() === '') {
			return alert(t('ModalAddGroup.errors.nameMissing'));
		}

		let params = {
			type,
			name,
			width,
			height,
			maxWidth,
			maxHeight,
			image: typeof image.filePath !== 'undefined' ? image.filePath : image
		};
		props.generate(params);
	}

	return (
		<div className="row">
			<div className="col-8">
				<Form
					hideBtn={true}
					injectData={{
						item: {
							fetching: false,
							loaded: true,
							props: {
								image,
								name,
								width,
								height
							}
						},
						launchMethod: (method, params) => {
							if (method === 'change') {
								let values = params[0];
								if (typeof values.image !== 'undefined' && values.image !== image) {
									setImage(values.image);
									updatePropsToChangeEstimate = true;
								}
								if (typeof values.name !== 'undefined' && values.name !== name) {
									setName(values.name);
								}
								if (fetchingEstimate === false) {
									if (typeof values.width !== 'undefined' && values.width !== false && values.width !== width) {
										setWidth(values.width);
										let ratio = maxHeight / maxWidth;
										let newHeight = parseInt(ratio * values.width, 10);
										setHeight(newHeight);
									}
									if (typeof values.height !== 'undefined' && values.height !== false && values.height !== height) {
										setHeight(values.height);
										let ratio = maxWidth / maxHeight;
										setWidth(parseInt(ratio * values.height, 10));
									}
								}
							}
						}
					}}
					inputs={[
						{
							label: t('OptionGroup.name'),
							name: 'name',
							required: true
						},
						{
							type: 'slider',
							label: t('OptionImage.width'),
							name: 'width',
							required: true,
							min: maxWidth !== false ? parseInt(maxWidth / 4, 10) : false,
							max: maxWidth,
							value: maxWidth !== false ? maxWidth : width,
							hide: estimate && estimate.width === false
						},
						{
							type: 'slider',
							label: t('OptionImage.height'),
							name: 'height',
							required: true,
							min: maxHeight !== false ? parseInt(maxHeight / 4, 10) : false,
							max: maxHeight,
							value: maxHeight !== false ? maxHeight : height,
							hide: estimate && estimate.height === false
						},
						{
							type: 'upload',
							label: t('OptionImage.image'),
							name: 'image',
							required: true
						}
					]}
				/>
			</div>
			<div className="col-4">
				{components.estimate}
				<div key="block7">
					<button
						type="button"
						className="btn btn-primary mb-1"
						onClick={generate}
					>
						{props.nameBtn}
					</button>
				</div>
			</div>

		</div>
	);
}

export default OptionImage;
